// $( document ).ready(function() {
//    var swiper = new Swiper(".home-page-swiper", {
//       direction: "vertical",
//       slidesPerView: 1,
//       speed: 1000,
//        autoHeight: true,
//       mousewheel: true,
//       centeredSlides: true,
//     roundLengths: true,
//     mousewheel: true,
//     grabCursor: true,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//     });
// });

$(document).ready(function(){
    $(".nav-icon").click(function(){
        $(this).toggleClass("active");
        if ($(this).hasClass("active")) {
            $("#mega-menu-disclosure").attr("open", true);
            $(".mega-menu").css("opacity", 1);
            $(".header__wrapper").addClass("active");
            $(".mega-menu").css("display", "block");
        } else {
            $("#mega-menu-disclosure").removeAttr("open");
            $(".mega-menu").css("opacity", 0);
            $(".header__wrapper").removeClass("active");
            $(".mega-menu").css("display", "none");
        }
    });
});



$(document).ready(function(){
    $(window).scroll(function(){
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
        var elementTop = $('.shopify-section--image-with-text-overlay').offset().top;
        var elementHeight = $('.shopify-section--image-with-text-overlay').outerHeight();

        if(windowBottom > elementTop + elementHeight){
            $('body').addClass('header-sticky');
        } else {
            $('body').removeClass('header-sticky');
        }
        
        // Check if the section is present in the viewport when scrolling back to the top
        var sectionVisible = isSectionVisible('.shopify-section--image-with-text-overlay');
        if(sectionVisible && $(this).scrollTop() === 0){
            $('body').removeClass('sticky');
        }
    });

    // Function to check if a section is visible in the viewport
    function isSectionVisible(sectionSelector){
        var windowBottom = $(window).scrollTop() + $(window).height();
        var sectionTop = $(sectionSelector).offset().top;
        return windowBottom > sectionTop;
    }
});

